import React, { FunctionComponent, useState } from "react";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import BrandAuthLayout from "../../layouts/BrandAuthLayout";
import NewPasswordRequiredForm from "./components/NewPasswordRequiredForm";
import RedesignedSignInForm from "./components/RedesignedSignInForm";
import SignInForm from "./components/SignInForm";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

const SignInPage: FunctionComponent = () => {
  const [isFirstAttempt, setFirstAttempt] = useState<boolean>(false);
  const [authUser, setAuthUser] = useState({});

  if (useNewDesign) {
    return (
      <BrandAuthLayout>
        {isFirstAttempt ? (
          <NewPasswordRequiredForm authUser={authUser} />
        ) : (
          <RedesignedSignInForm setFirstAttempt={setFirstAttempt} setAuthUser={setAuthUser} />
        )}
      </BrandAuthLayout>
    );
  }

  return (
    <AuthFlowLayout
      heading="Welcome Back"
      description="Log in: to view your personalized dashboard, campaigns, and audiences."
    >
      {isFirstAttempt ? (
        <NewPasswordRequiredForm authUser={authUser} />
      ) : (
        <SignInForm setFirstAttempt={setFirstAttempt} setAuthUser={setAuthUser} />
      )}
    </AuthFlowLayout>
  );
};

export default SignInPage;
